import type { OnDestroy, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { shareReplay, takeUntil, Subject } from 'rxjs';
import { ROUTE_PATH_PARAM_ORDER_ID } from '@studiobuki/web-core/lib/routing';
import { RoutingService } from 'src/app/services/routing.service';
import { MediaService } from '@studiobuki/web-core/lib/media';
import { map, switchMap, take } from 'rxjs/operators';
import { FirebaseService } from 'src/app/services/firebase.service';
import { LoaderService } from '@studiobuki/web-core/lib/loader';
import { filterNullable } from '@studiobuki/web-core';
import { checkGeneratedGiftOrder } from '@shared/jp/gift';
import Subscriber from '@shared/common/subscriber';

@Component({
  templateUrl: './gift-thanks-page.component.html',
  styleUrls: ['./gift-thanks-page.component.scss'],
})
export class GiftThanksPageComponent implements OnInit, OnDestroy {
  private readonly _destroy$ = new Subject<void>();

  public readonly orderId$ = this._route.queryParamMap.pipe(
    map((queryParamMap) => queryParamMap.get(ROUTE_PATH_PARAM_ORDER_ID)),
    shareReplay(1),
    takeUntil(this._destroy$),
  );

  public readonly order$ = this.orderId$.pipe(
    filterNullable(),
    switchMap((orderId) => this._firebaseService.loadUserGiftOrder(orderId)),
    shareReplay(1),
    takeUntil(this._destroy$),
  );

  /**
   * * BARCODE
   */
  public readonly giftOrderId$ = this.order$.pipe(
    filterNullable(),
    map(
      (order) =>
        (checkGeneratedGiftOrder(order) && order.giftOrderId) || undefined,
    ),
    filterNullable(),
    shareReplay(1),
    takeUntil(this._destroy$),
  );

  public readonly giftId$ = this.order$.pipe(
    filterNullable(),
    map((order) => {
      const giftId = 'gifts' in order && order.gifts[0];

      return giftId || '';
    }),
    filterNullable(),
    shareReplay(1),
    takeUntil(this._destroy$),
  );

  // * comments are left to implement the konbini logic
  // public readonly payment$ = this.orderId$.pipe(
  //   filterNullable(),
  //   switchMap((orderId) =>
  //     this._firebaseService.getStripeGiftCheckout$(orderId),
  //   ),
  //   shareReplay(1),
  //   takeUntil(this._destroy$),
  // );

  // public readonly hostedVoucherUrl$ = this.payment$.pipe(
  //   filterNullable(),
  //   map((payment) => {
  //     const hostedVoucherUrl = (payment as any)?.next_action
  //       ?.konbini_display_details?.hosted_voucher_url;

  //     return (hostedVoucherUrl as string | undefined) || '';
  //   }),
  //   shareReplay(1),
  //   takeUntil(this._destroy$),
  // );

  private _sub = new Subscriber();

  constructor(
    private _firebaseService: FirebaseService,
    private _route: ActivatedRoute,
    private _loaderService: LoaderService,
    public routing: RoutingService,
    public media: MediaService,
  ) {
    this._loaderService.show();
  }

  ngOnInit(): void {
    this._sub.push(
      // * stop loader when one of observables emits the value
      // do not check for giftId because it can be empty in gift special order
      // race([this.giftOrderId$, this.hostedVoucherUrl$])
      this.giftOrderId$.pipe(take(1)).subscribe((/* [order, payment] */) => {
        this._loaderService.hide();
      }),
    );
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
    this._sub.unsubscribe();
  }
}
